<template>
    <div>
        <div class="kgr-row">
            <div class="kgr-col">
                <div class="kgr-inputGroup kgr-inputGroup--inline">
                    <div
                        v-t="'clubRoles.default'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-checkbox-group
                        :value="value"
                        :options="defaultRoles"
                        field-for-label="displayName"
                        @post-input="update"
                    />
                </div>
            </div>
            <div
                v-if="customRoles.length > 0"
                class="kgr-col"
            >
                <div class="kgr-inputGroup kgr-inputGroup--inline">
                    <div
                        v-t="'Individuelle Rollen'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-checkbox-group
                        :value="value"
                        :options="customRoles"
                        field-for-label="displayName"
                        @post-input="update"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckboxGroup from '../checkbox/CheckboxGroup';

export default {
    components: {
        'kgr-checkbox-group': CheckboxGroup,
    },
    props: {
        value: {
            type: Array,
            required: false,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    computed: {
        defaultRoles() {
            return this.options.filter((r) => !r.custom);
        },
        customRoles() {
            return this.options.filter((r) => r.custom);
        },
    },
    methods: {
        update(selectedRoles) {
            this.$emit('input', selectedRoles);
            this.$nextTick(() => {
                this.$emit('post-input', selectedRoles);
            });
        },
    },
};
</script>
